import React from 'react';

import './styles.css';

const Section = ({children, number, heading}) => (
  <div className="Section">
    <div className="header">
      <div className="number">{number}</div>
      <div className="heading">{heading}</div>
    </div>
    <div className="content">{children}</div>
  </div>
);

export default Section;
